<template>
  <div class="chip-group">
    <AppChip
      v-for="item in items"
      :key="item.id"
      :item="item"
      :is-active="selectedIds.includes(item.id)"
      @toggle="toggleItem"
    />
  </div>
</template>

<script>
import AppChip from '@/uikit/components/AppChip/AppChip.vue';

export default {
  name: 'AppChipGroup',
  components: { AppChip },
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedIds: [...this.value],
    };
  },
  watch: {
    value(newVal) {
      this.selectedIds = [...newVal];
    },
  },
  methods: {
    toggleItem(id) {
      const index = this.selectedIds.indexOf(id);
      if (index === -1) {
        this.selectedIds.push(id);
      } else {
        this.selectedIds.splice(index, 1);
      }
      this.$emit('input', this.selectedIds);
    },
  },
};
</script>

<style scoped>
.chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
</style>



// WEBPACK FOOTER //
// AppChipGroup.vue?03239cf1